// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (max-width: 600px) {\n.container[data-v-256d1013] {\n  padding: 0px;\n}}\n", ""]);
// Exports
module.exports = exports;
